export default {
  phoneNumber:'021-80183707'
}



// WEBPACK FOOTER //
// ./src/common/constants.js